import "./paymentCallback.css";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

const CALLBACK_STORAGE_KEY = "payment_callback_shown";

const messages = {
  "deposit-successful": {
    title: "Deposit Successful!",
    subtitle: "Your balance has been updated.",
    type: "success",
  },
  "deposit-failed": {
    title: "Deposit Failed",
    subtitle: "Unable to process your deposit. Please retry in a moment.",
    type: "error",
  },
  "withdraw-successful": {
    title: "Withdrawal successful!",
    subtitle: "Your request has been processed.",
    type: "success",
  },
  "withdraw-failed": {
    title: "Withdrawal Failed",
    subtitle: "Please try again or contact support.",
    type: "error",
  },
};

function PaymentCallback() {
  const location = useLocation();
  const [data, setData] = useState(null);
  const isDarkMode = useSelector((state) => state.theme.darkMode);

  useEffect(() => {
    const fullPath = location.pathname;
    const segments = fullPath.split("/").filter(Boolean);
    const routePrefix = segments[0];
    const transactionId = segments[1] || "unknown";

    if (!messages[routePrefix]) return;

    const uniqueKey = `${routePrefix}_${transactionId}`;
    const shownData =
      JSON.parse(localStorage.getItem(CALLBACK_STORAGE_KEY)) || {};

    if (!shownData[uniqueKey]) {
      setData(messages[routePrefix]);
      const updated = { ...shownData, [uniqueKey]: true };
      localStorage.setItem(CALLBACK_STORAGE_KEY, JSON.stringify(updated));
    } else {
      setData(null);
    }
  }, [location.pathname]);

  if (!data) return null;

  const isSuccess = data.type === "success";

  return (
    <div className={`payment-callback-overlay ${isDarkMode ? "dark" : "light"}`}>
      <div className="payment-callback-card">
        {/* Icon */}
        <div className={`payment-callback-icon ${isSuccess ? "success" : "error"}`}>
          {isSuccess ? "✓" : "✕"}
        </div>

        {/* Text */}
        <div className="payment-callback-text">
          <h2 className={`payment-callback-title ${isSuccess ? "success" : "error"}`}>
            {data.title}
          </h2>
          <p className="payment-callback-subtitle">{data.subtitle}</p>
        </div>
      </div>
    </div>
  );
}

export default PaymentCallback;